import { createAction, createReducer } from "redux-act";
import { createSelector } from "reselect";
import { produce } from "immer";
import { ExtendedProjectInfoDc } from "@evergis/api";

import { reducerRegistry } from "./reducerRegistry";

import { RootState } from "./reducers";
import { ConfigurationsTab, ProjectConfigurationTab } from "../modules/Configuration/types";
import { ProjectInfo } from "../interfaces/resourceInfo";

export const reducerName = "projectConfig";

export interface ProjectConfigState {
  tab: ConfigurationsTab;
  tempConfig: ExtendedProjectInfoDc;
  tempConfigDate: Date;
}

const initialState: ProjectConfigState = {
  tempConfig: null,
  tempConfigDate: null,
  tab: {
    name: ProjectConfigurationTab.Resource,
  },
};

export const getProjectConfig = ({ projectConfig }: RootState): ProjectConfigState => projectConfig;

export const getProjectConfigTab = createSelector(getProjectConfig, config => config?.tab);

export const getProjectTempConfig = createSelector(getProjectConfig, config => config?.tempConfig);

export const getProjectTempConfigDate = createSelector(getProjectConfig, config => config?.tempConfigDate);

export const setProjectConfig = createAction<ProjectConfigState>(`${reducerName}/setConfig`);

export const setProjectConfigTab = createAction<ConfigurationsTab>(`${reducerName}/setConfigTab`);

export const setProjectTempConfig = createAction<ProjectInfo>(`${reducerName}/setTempConfig`);

export const setProjectTempConfigDate = createAction<Date>(`${reducerName}/setTempConfigDate`);

export const reducer = createReducer({}, initialState).on(setProjectConfig, (_, projectConfig) => projectConfig);

reducer.on(
  setProjectConfigTab,
  produce((state, tab: ConfigurationsTab) => {
    state.tab = tab;
  }),
);

reducer.on(
  setProjectTempConfig,
  produce((state, info: ProjectInfo) => {
    state.tempConfig = info;
  }),
);

reducer.on(
  setProjectTempConfigDate,
  produce((state, date: Date) => {
    state.tempConfigDate = date;
  }),
);

reducerRegistry.register(reducerName, reducer);
